import React from 'react';
import { Img } from '../../../hybrid/wrappers';
import css from './Plug.module.scss';
import CustomUiButton from '../../customUiButton/CustomUiButton';
import classnames from 'classnames';

const Plug = ({
    plugImg,
    plugTitle,
    plugDescription,
    btnGroups = [],
    styles = {},
    classes = {},
    additional_component = {},
    customPlugImg = null
}) => {
    const custom_class_plugContainer = classes?.plugContainer ? [...classes?.plugContainer] : [];
    const custom_class_img = classes?.plugImg ? [...classes?.plugImg] : [];
    const custom_class_plugTitle = classes?.plugTitle ? [...classes?.plugTitle] : [];
    const custom_class_plugDescription = classes?.sss ? [...classes?.plugDescription] : [];
    const custom_class_btnGroup = classes?.btnGroup ? [...classes?.btnGroup] : [];

    return (
        <div className={classnames(css.plugContainer, ...custom_class_plugContainer)}>
            {customPlugImg}
            {plugImg ? <Img src={plugImg} width={220} height={150} className={custom_class_img} /> : null}

            {plugTitle ? <div className={classnames(css.plugTitle, ...custom_class_plugTitle)}>{plugTitle}</div> : null}

            {plugDescription ? (
                <div className={classnames(css.plugDescription, ...custom_class_plugDescription)}>{plugDescription}</div>
            ) : null}

            {additional_component?.before_btns ? additional_component?.before_btns : null}

            {btnGroups.map((group, i) => {
                return (
                    <div
                        key={'CustomUiBtnGroup' + i + plugTitle}
                        className={classnames(css.btnGroup, ...custom_class_btnGroup)}
                        style={styles?.btnGroup ? { ...styles?.btnGroup } : {}}
                    >
                        {group.map((btn, index) => (
                            <CustomUiButton key={'CustomUiBtn' + index + i + plugTitle} {...btn} />
                        ))}
                    </div>
                );
            })}
        </div>
    );
};

export default Plug;
